module.exports = __webpack_public_path__ + "static/media/chat.317ce2f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/chat.svg
// module id = 1809
// module chunks = 0